(function(){
    const modals = document.querySelectorAll('[data-modal]') as NodeListOf<HTMLElement>;
    const body = document.querySelector('body') as HTMLElement;

    modals.forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
            event.preventDefault();
            const modal = document.getElementById(trigger.dataset.modal as string) as HTMLElement;
            const iframe = document.querySelector('iframe') as HTMLIFrameElement;
            const temp = iframe.src;       

            if (modal) {
                modal.classList.add('open');
                body.classList.add('modal-open');
            }

            const exits = modal.querySelectorAll('.video-modal-close') as NodeListOf<HTMLButtonElement>;
            exits.forEach((exit) => {
                exit.addEventListener('click', function (event) {
                    event.preventDefault();
                    iframe.src = temp;
                    modal.classList.remove('open');
                    body.classList.remove('modal-open');
                });
            });

            const handleKeyDown = (evt: KeyboardEvent) => {
                if (evt.key == "Escape" || evt.key == "Esc") {
                    modal.classList.remove('open');
                    body.classList.remove('modal-open');
                    document.removeEventListener('keydown', handleKeyDown);
                }
            }
            
            document.addEventListener('keydown', handleKeyDown);
        });
    });
})();